module.exports = __webpack_public_path__ + "static/img/icon_up.838b377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImg/icon_up.png
// module id = 1363
// module chunks = 72